import { get } from 'lodash';

/**
 * This function is occasionally called with nested string params that
 * lodash's get function relies on (e.g. getProps('foo.bar')), which is why
 * we are leaving this in place for the time being.
 *
 * Note on the generic - ultimately we should swap to a better type like unknown
 */
export function getProp<T = any>(
  req: Nullable<Request>,
  propName: string,
): T | undefined {
  if (req) {
    return get(req, `props.${propName}`);
  }

  if (typeof window !== 'undefined') {
    return get(window, propName);
  }
}
